var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.1,
    transform: "rotate(30 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.1,
    transform: "rotate(60 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.1,
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.19,
    transform: "rotate(120 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.28,
    transform: "rotate(150 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.38,
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.46,
    transform: "rotate(210 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.55,
    transform: "rotate(240 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.64,
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.73,
    transform: "rotate(300 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.63 8.23a7.38 7.38 0 0 1 2.7 10.07L89.2 37.57a7.38 7.38 0 1 1-12.77-7.37l11.12-19.27a7.38 7.38 0 0 1 10.08-2.7z",
    fill: "#ffffff",
    fillOpacity: 0.82,
    transform: "rotate(330 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
    calcMode: "discrete",
    dur: "720ms",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSending);
export default __webpack_public_path__ + "static/media/sending.8c1e77151a9f867a53c4cea97392d799.svg";
export { ForwardRef as ReactComponent };